<script lang="ts">
  export let width = 4
  export let size = 32
  export let rotate = 0
  export let value = 0
  export let indeterminate = false
  export let style: string | undefined = undefined
  export let underlayStrokeWidth: number | undefined = undefined
  export let overlayStrokeWidth: number | undefined = undefined

  const radius = 20
  const circumference = 2 * Math.PI * radius
  $: diameter = (radius / (1 - width / size)) * 2
  $: strokeWidth = (width / size) * diameter
  $: strokeDashOffset = ((100 - value) / 100) * circumference
</script>

<div
  class="container"
  class:indeterminate
  style={style
    ? `height: ${size}px; width: ${size}px; ${style}`
    : `height: ${size}px; width: ${size}px;`}
  role="progressbar"
  aria-valuemin={0}
  aria-valuemax={100}
  aria-valuenow={indeterminate ? undefined : value}
>
  <svg
    style={`transform: rotate(calc(-90deg + ${rotate}deg))`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 ${diameter} ${diameter}`}
  >
    <circle
      class="underlay"
      fill="transparent"
      cx="50%"
      cy="50%"
      r={radius}
      stroke-width={underlayStrokeWidth || strokeWidth}
      stroke-dasharray={circumference}
      stroke-dashoffset={0}
    />

    <circle
      class="overlay"
      fill="transparent"
      cx="50%"
      cy="50%"
      r={radius}
      stroke-width={overlayStrokeWidth || strokeWidth}
      stroke-dasharray={circumference}
      stroke-dashoffset={strokeDashOffset}
    />
  </svg>
</div>

<style lang="scss">
  .container {
    align-items: center;
    display: inline-flex;
    justify-content: center;
    position: relative;
    vertical-align: middle;

    svg {
      width: 100%;
      height: 100%;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 0;

      .underlay {
        color: rgba(160, 200, 227, 0.12);
        stroke: var(--circular-progress-underlay-color, currentColor);
        z-index: 1;
      }

      .overlay {
        stroke: var(--circular-progress-color, var(--color-primary));
        transition:
          all 0.2s ease-in-out,
          stroke-width 0s;
        z-index: 2;
      }
    }
  }

  .indeterminate {
    svg {
      animation: circular-progress-rotate 1.4s linear infinite;
      transform-origin: center center;
      transition: all 0.2s ease-in-out;

      .overlay {
        animation: circular-progress-dash 1.4s ease-in-out infinite;
        stroke-dasharray: 25, 200;
        stroke-dashoffset: 0;
        stroke-linecap: round;
      }
    }
  }

  @keyframes circular-progress-dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0px;
    }

    50% {
      stroke-dasharray: 100, 200;
      stroke-dashoffset: -15px;
    }

    100% {
      stroke-dasharray: 100, 200;
      stroke-dashoffset: -124px;
    }
  }

  @keyframes circular-progress-rotate {
    100% {
      transform: rotate(270deg);
    }
  }
</style>
